export default __webpack_public_path__ + "static/0235-65536527173691a0b1d62558d35b4ae4.png";